{
  "main": {
    "title": "Elenco dei club",
    "nazaj": "Indietro"
  },
  "navs": {
    "vnos": "Aggiungi",
    "seznam": "Elenco"
  },
  "table": {
    "sifra": "Codice",
    "naziv": "Nome",
    "naslov": "Indirizzo",
    "podrobno": "Dettagli"
  },
  "modal": {
    "sifra": "Codice:",
    "naziv": "Nome:",
    "naslov": "Indirizzo:",
    "posta": "CAP:",
    "kraj": "Città:",
    "email": "E-mail:",
    "telefon": "Telefono:"
  },
  "buttons": {
    "csv": "Esporta in CSV",
    "uredi": "Modifica dati",
    "posodobi": "Aggiorna dati",
    "brisi": "Elimina club"
  }
}